// chartConfig.ts
import { MarkerType } from 'reactflow';
import { ChartNode } from './Types';

export const NAVGREEN = '#007934';

// Desktop layout constants
export const CHART_WIDTH = 1200;
export const CARD_WIDTH = 220;
export const TOP_CARD_WIDTH = 380;
export const GAP = 0;

const totalWidth = (CARD_WIDTH * 3) + (GAP * 2);
const startX = (CHART_WIDTH - totalWidth) / 2 - 3;
const topCardX = (CHART_WIDTH / 2) - (TOP_CARD_WIDTH / 2) + 20;

// Mobile layout constants
export const MOBILE_CHART_WIDTH = 320;
export const MOBILE_CARD_WIDTH = 180;
export const MOBILE_TOP_CARD_WIDTH = 280;
export const MOBILE_GAP = 8;

const mobileTotalWidth = (MOBILE_CARD_WIDTH * 3) + (MOBILE_GAP * 2);
const mobileStartX = (MOBILE_CHART_WIDTH - mobileTotalWidth) / 2;
const mobileTopCardX = (MOBILE_CHART_WIDTH / 2) - (MOBILE_TOP_CARD_WIDTH / 2);

// Desktop nodes layout
export const initialNodes: ChartNode[] = [
  {
    id: '1',
    type: 'custom',
    position: { x: topCardX, y: 10 },
    data: {
      name: 'Rahul Doshi',
      position: 'Interim Head - Finance',
      initials: 'RD',
      avatar: 'assets/org-chart-profile-one.svg',
      type: 'main',
      
    },
  },
  {
    id: '2',
    type: 'custom',
    position: { x: startX, y: 300 },
    data: {
      name: 'Gourav Kumar Gupta',
      position: 'Deputy Manager - AR',
      initials: 'GG',
      avatar: 'assets/org-chart-profile-two.svg',
      type: 'sub',
    },
  },
  {
    id: '3',
    type: 'custom',
    position: { x: startX + CARD_WIDTH + GAP, y: 300 },
    data: {
      name: 'Harsha Stephen',
      position: 'Deputy Manager - Finance',
      initials: 'HS',
      avatar: 'assets/org-chart-profile-three.svg',
      type: 'sub',
    },
  },
  {
    id: '4',
    type: 'custom',
    position: { x: startX + (CARD_WIDTH + GAP) * 2, y: 300 },
    data: {
      name: 'Dhaval Atul Parikh',
      position: 'Manager - Finance',
      initials: 'DP',
      avatar: 'assets/org-chart-profile-four.svg',
      type: 'sub',
    },
  },
];

// Mobile nodes layout
export const mobileNodes: ChartNode[] = [
  {
    id: '1',
    type: 'custom',
    position: { x: mobileTopCardX, y: -5 },
    data: {
      name: 'Rahul Doshi',
      position: 'Interim Head - Finance',
      initials: 'RD',
      avatar: 'assets/org-chart-profile-one.svg',
      type: 'main',
    },
  },
  {
    id: '2',
    type: 'custom',
    position: { x: mobileStartX - 10, y: 220 },
    data: {
      name: 'Gourav Kumar Gupta',
      position: 'Deputy Manager - AR',
      initials: 'GG',
      avatar: 'assets/org-chart-profile-two.svg',
      type: 'sub',
    },
  },
  {
    id: '3',
    type: 'custom',
    position: { x: mobileStartX + MOBILE_CARD_WIDTH + MOBILE_GAP - 10, y: 220 },
    data: {
      name: 'Harsha Stephen',
      position: 'Deputy Manager - Finance',
      initials: 'HS',
      avatar: 'assets/org-chart-profile-three.svg',
      type: 'sub',
    },
  },
  {
    id: '4',
    type: 'custom',
    position: { x: mobileStartX + (MOBILE_CARD_WIDTH * 2) + (MOBILE_GAP * 2) - 10, y: 220 },
    data: {
      name: 'Dhaval Atul Parikh',
      position: 'Manager - Finance',
      initials: 'DP',
      avatar: 'assets/org-chart-profile-four.svg',
      type: 'sub',
    },
  },
];

// Chart edges
export const initialEdges = [
  {
    id: 'e1-2',
    source: '1',
    target: '2',
    type: 'smoothstep',
    animated: true,
    style: {
      stroke: NAVGREEN,
      strokeWidth: 3,
      strokeDasharray: '0',
    },
    markerEnd: {
      type: MarkerType.ArrowClosed,
      color: NAVGREEN,
      width: 14,
      height: 14,
    },
  },
  {
    id: 'e1-3',
    source: '1',
    target: '3',
    type: 'straight',
    animated: true,
    style: {
      stroke: NAVGREEN,
      strokeWidth: 3,
      strokeDasharray: '0',
    },
    markerEnd: {
      type: MarkerType.ArrowClosed,
      color: NAVGREEN,
      width: 14,
      height: 14,
    },
  },
  {
    id: 'e1-4',
    source: '1',
    target: '4',
    type: 'smoothstep',
    animated: true,
    style: {
      stroke: NAVGREEN,
      strokeWidth: 3,
      strokeDasharray: '0',
    },
    markerEnd: {
      type: MarkerType.ArrowClosed,
      color: NAVGREEN,
      width: 14,
      height: 14,
    },
  },
];